import { render, staticRenderFns } from "./FreemiumSubscriptionPopup.vue?vue&type=template&id=690e3be5&scoped=true"
import script from "./FreemiumSubscriptionPopup.vue?vue&type=script&lang=ts"
export * from "./FreemiumSubscriptionPopup.vue?vue&type=script&lang=ts"
import style0 from "./FreemiumSubscriptionPopup.vue?vue&type=style&index=0&id=690e3be5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e3be5",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QBtn,QChip,QIcon,QCardActions,QCarousel,QCarouselSlide});qInstall(component, 'directives', {ClosePopup});
